import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'letter-h', 'LetterH', [["path",{"d":"M17 4l0 16"}],["path",{"d":"M7 12l10 0"}],["path",{"d":"M7 4l0 16"}]]);